<p-dialog
  [header]="headerKey | abpLocalization"
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  [style]="{ width: '28rem', maxWidth: '90vw' }"
  (onHide)="onHide()">
  <form class="d-flex flex-column gap-2" [formGroup]="form" (ngSubmit)="onSave()">
    <label for="segmentName" class="form-label mb-0">
      {{ 'Settings::CRM:Definitions:Name' | abpLocalization }}
    </label>
    <input
      id="segmentName"
      type="text"
      pInputText
      [cxPendingLoader]="isValidating"
      class="form-control"
      maxlength="100"
      formControlName="name"
      [placeholder]="'Settings::CRM:Definitions:NamePlaceholder' | abpLocalization" />
  </form>

  <ng-template #footer>
    <cx-form-actions
      layout="dialog"
      [cancelLabel]="'AbpUi::Cancel' | abpLocalization"
      [saveLabel]="'::Save' | abpLocalization"
      saveType="button"
      [disabled]="form.invalid || isBusy"
      [isSubmitting]="isBusy"
      (cancel)="onCancel()"
      (save)="onSave()">
    </cx-form-actions>
  </ng-template>
</p-dialog>
